import { useSelector } from 'react-redux';
import { useAnalytics } from '../../hooks/useAnalytics';

// Component to handle user-specific analytics initialization
function AnalyticsProvider({ children }) {
    const user = useSelector(state => state.auth.user);

    // Initialize analytics with user ID when available
    useAnalytics(user?.uid);

    return children;
}

export default AnalyticsProvider;
